import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QAOffering from "@/pages/QAOffering";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/qa-support-outsourcing")({
  head: () => buildRouteHead("/zh-cn/services/quality-assurance/qa-support-outsourcing"),
  component: QAOffering,
});
